<!-- @format -->

<div class="selectable-container hmf-display-flex hmf-flex-column hmf-gap-xxs hmf-w-100">

	<!-- Pickup Section -->
	<div class="location-info hmf-display-flex hmf-align-items-start">
		<span aria-hidden="true" class="hmf-body-m hmf-mr-xxxs">{{ sectionHeaders().pickup.label }}</span>
		<button
			hmf-action-text
			class="hmf-body-bold-m"
			[attr.aria-label]="sectionHeaders().pickup.label + ', ' + sectionHeaders().pickup.value"
			variant="secondary"
			(click)="changeLocationAndStoreName.emit('pickup')">
			{{ sectionHeaders().pickup.value | titlecase }}
		</button>
	</div>

	@for (option of pickupOptions(); track option.key) {
		<ng-container
			[ngTemplateOutlet]="selectableOption"
			[ngTemplateOutletContext]="{ $implicit: option }" />
	}

	<!-- Ship Section -->
	<div class="location-info hmf-display-flex hmf-align-items-start hmf-mt-xxs">
		<span aria-hidden="true" class="hmf-body-m hmf-mr-xxxs">{{ sectionHeaders().ship.label }}</span>
		<button
			hmf-action-text
			class="hmf-body-bold-m"
			[attr.aria-label]="sectionHeaders().ship.label + ', ' + sectionHeaders().ship.value"
			variant="secondary"
			(click)="changeLocationAndStoreName.emit('ship')">
			{{ sectionHeaders().ship.value | titlecase }}
		</button>
	</div>

	@for (option of shipOptions(); track option.key) {
		<ng-container
			[ngTemplateOutlet]="selectableOption"
			[ngTemplateOutletContext]="{ $implicit: option }" />
	}
</div>

<ng-template #selectableOption let-option>
	@let selectedOption = $safeNavigationMigration(currentSelectedOptions()?.includes(option.key));
	@let isDisabled = isOptionDisabled()(option.key);
	<hmf-selectable
		[id]="option.key.toLowerCase()"
		[type]="'contained'"
		[border]="'single'"
		[shape]="'rectangle'"
		[width]="'100%'"
		[height]="'100%'"
		[disabled]="isDisabled"
		[selected]="selectedOption"
		[attr.aria-label]="option.label + ', ' + option.subtitleOption + ' ' + (fulfillmentFacetsEnabled() && hasFulfillmentData() ? (fulfillmentFacets()[option.key] ?? 0) + ' available' : '')"
		[attr.data-option-key]="option.key"
		(handleClick)="handleOptionSelection(option.key)">
		<div class="selectable-content hmf-display-flex hmf-align-items-center hmf-justify-content-between hmf-w-100 fill-base hmf-px-s hmf-py-xs hmf-gap-s">
			<div class="hmf-display-flex hmf-align-items-center hmf-gap-xs">
				<homefield-icon
					class="option-icon-fill"
					[class.select]="selectedOption"
					[class.disabled]="isDisabled"
					[name]="selectedOption ? option.icon.selected : option.icon.unselected">
				</homefield-icon>
				<div class="selectable-label hmf-display-flex hmf-flex-column hmf-text-align-left">
					<span
						class="hmf-body-l label-base"
						[class.hmf-body-bold-l]="selectedOption"
						[class.label-disabled]="isDisabled"
						[attr.aria-label]="option.label"
					>
						{{ option.label }}
					</span>
					<span
						class="hmf-body-m label-base-subtle"
						[class.label-positive]="option.key === 'BOPIS' && !isDisabled"
						[class.hmf-body-bold-m]="option.key === 'BOPIS' && selectedOption"
						[class.label-disabled]="isDisabled"
						[attr.aria-label]="option.subtitleOption"
					>{{ option.subtitleOption }}</span>
				</div>
			</div>
			@if (fulfillmentFacetsEnabled() && hasFulfillmentData()) {
				<span
					class="hmf-body-m"
					[class.hmf-body-bold-m]="selectedOption"
					[class.label-disabled]="isDisabled"
				>{{ fulfillmentFacets()[option.key]?.toLocaleString('en-US') ?? 0 }}</span>
			}
		</div>
	</hmf-selectable>
</ng-template>